// Диапазон дат для partner-эндпоинтов по числу дней.
export const rangeFor = (days) => {
    const to = new Date();
    const from = new Date();
    from.setDate(from.getDate() - (days - 1));
    const fmt = (d) => d.toISOString().slice(0, 10);
    return { dateFrom: fmt(from), dateTo: fmt(to) };
};

export const PERIOD_OPTIONS = [
    { value: 30, label: '30 дней' },
    { value: 90, label: '90 дней' },
];